import campaignApi from '../_api';

export default {
  namespaced: true,

  state: {
    allCities: null,
  },
  // -----------------------------------------------------------------
  getters: {
    allCities: (state,) => state.allCities,
  },
  // -----------------------------------------------------------------
  mutations: {
    setAllCities: (state, cities,) => (state.allCities = cities),
  },
  // -----------------------------------------------------------------
  actions: {
    getBonds (_, _id,) {
      return _api.getBonds(_id,);
    },

    getCities ({ commit, }, { franchises, page, search, size, from, all,},) {
      return campaignApi.getCities({
        franchises,
        page,
        search,
        size: all ? 9999 : size,
        from,
      },).then((response,) => {
        const { data, } = response;
        const { cities, } = data;

        if (all) {
          commit('campaignBounds/setAllCities', cities.map((city,) => city.id,), { root: true, },);
        }

        function formatCities (cities,) {
          return cities.map((city,) => {
            return {
              id: String(city.id,),
              text: `${city.name} - ${city.state.acronym}`,
              checked: false,
              visible: false,
            };
          },);
        }

        data.cities = formatCities(cities,);

        return data;
      },);
    },

    getCompanies (_, { franchises, page, search, size, from, cities, },) {
      return campaignApi.
        getCompanies({ franchises, page, search, size, from, cities, },).then(
          (response,) => {
            const data = response.data;
            data.companies = [
              ...response.data.companies.map((company,) => {
                return {
                  uuid: company.uuid,
                  text: `${company.name} - ${company.city} - ${company.uf}`,
                  city_id: company.city_id,
                  checked: false,
                  visible: false,
                };
              },),
            ];
            return data;
          },
          (error,) => {
            console.error(error,);
          },
        );
    },

    getCompanyCampaigns (_, { campaignId, cities, type, from, size, company_name, },) {
      return campaignApi.getCompanyCampaigns({
        campaignId,
        cities,
        type,
        from,
        size,
        company_name,
      },);
    },

    createBound (_, {campaign_id, type, init_date, end_date, cities,},) {
      return new Promise((resolve, reject,) => {
        campaignApi.createBound({
          campaign_id,
          type,
          init_date,
          end_date,
          cities,
        },).
          then((response,) => {
            resolve(response,);
          },).
          catch((error,) => {
            reject(error.response,);
          },);
      },);
    },

    updateBound (_, {id, init_date, end_date, },) {
      return new Promise((resolve, reject,) => {
        campaignApi.updateBound({id, init_date, end_date, },).
          then(() => resolve(),).
          catch((error,) => reject(error.response.data.errors,),);
      },);
    },

    deleteCampaigns (_, { campaignId, bounds, },) {
      return campaignApi.deleteCampaigns({ campaignId, bounds, },);
    },

    deleteCampaign (_, { campaignId, },) {
      return campaignApi.deleteCampaign({ campaignId, },);
    },

    toggleCampaignStatus (_, { campaignId, type, },) {
      return campaignApi.toggleCampaignStatus({ campaignId, type, },);
    },
  },
};
